import { Injectable } from '@angular/core';
import { User } from '../_models/user';
import { Firestore, collection, addDoc, doc, setDoc } from '@angular/fire/firestore';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(private firestore: Firestore) { }

  public logUser(user: User, schoolId: string, path: string) {

    // Staging and production are both considered production environments, so we only log in production.
    if (!environment.production) {
      return;
    }

    if (user) {
      const userLog = {
        email: user.email || '',
        schoolId: schoolId || '',
        path: path || '',
        time: new Date(Date.now()),
        id: user.uid || ''
      };
      addDoc(collection(this.firestore, 'logging'), userLog);
      if (!user.admin) {
        const schoolDocRef = doc(this.firestore, 'schools', schoolId);
        setDoc(schoolDocRef, { lastLogIn: new Date(Date.now()) }, { merge: true });
      }
    }

  }
}